var render = function render(){var _vm=this,_c=_vm._self._c,_setup=_vm._self._setupProxy;return _c('div',{ref:"content",staticClass:"set-normal"},[_c('tData')],1)
}
var staticRenderFns = []

export { render, staticRenderFns }